<template>
  <section>
    <div class="tip" style="margin:0 0 0 20px">* 项目基本资料</div>
    <el-form-item label="项目名称" v-if="project.name">
      <el-input size="small" v-model="project.name" :disabled="true" placeholder="请输入项目名称"></el-input>
    </el-form-item>
    <el-form-item label="合同名称" v-if="contract.name">
      <el-input size="small" v-model="contract.name" :disabled="true" placeholder="请输入项目名称"></el-input>
    </el-form-item>
    <el-form-item label="申报单位">
      <el-input size="small" :disabled="true" v-model="userData.department.split('/')[0]"></el-input>
    </el-form-item>
    <div class="clear">
      <el-col :span="12">
        <el-form-item label="项目负责人">
          <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="联系方式">
          <el-input size="small" :disabled="true" v-model="userData.mobile"></el-input>
        </el-form-item>
      </el-col>
    </div>

    <el-form-item label="废弃原因">
      <el-input type="textarea" placeholder="请简明扼要地说明项目废弃原因" :autosize="{ minRows: 5, maxRows: 8}" size="small"
        v-model="form.reason"></el-input>
    </el-form-item>

  </section>
</template>

<script>
  export default {
    props: ['project', 'contract', 'formByFather', 'userData', 'teamArr', 'projectArr'],
    data() {
      return {
        form: {},
      }
    },
    mounted() {
      this.form = this.formByFather

      this.form.depId = this.userData.secDepIds.split(",")[0]
    },
    methods: {
      getFromData() {
        return this.form
      }
    },
    watch: {
      formByFather() {
        this.form = this.formByFather
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/createDiscardApproval.vue